export default __webpack_public_path__ + "static/media/factory__22.c8f0a03e.jpg";